// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.secret-content-left[data-v-05db9347] {\n  display: inline-block;\n  width: 48%;\n  text-align: left;\n}\n.secret-content-right[data-v-05db9347] {\n  display: inline-block;\n  width: 51%;\n  text-align: right;\n}\n\n", ""]);
// Exports
module.exports = exports;
